import IconBase from "./IconBase";

const SparklesIcon = props => (
  <IconBase data-testid="SparklesIcon" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7 10.004C7.836 9.168 8.503 8.167 9 7c.5 1.166 1.167 2.167 2 3.004.833.837 1.833 1.502 3 1.996-1.168.501-2.168 1.168-3 2-.832.832-1.499 1.832-2 3-.5-1.171-1.167-2.171-2-3-.833-.829-1.833-1.495-3-2 1.164-.495 2.164-1.16 3-1.996z"
      />
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.25 5.25c.334-.334.584-.751.75-1.25.167.499.417.915.75 1.25.333.335.75.585 1.25.75-.5.167-.917.417-1.25.75-.333.333-.583.75-.75 1.25a3.118 3.118 0 0 0-.75-1.25c-.353-.344-.78-.6-1.25-.75.47-.148.898-.405 1.25-.75h0z"
      />
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.833 3.833c.335-.333.557-.778.667-1.333.111.554.334.999.667 1.333.333.335.777.557 1.333.667-.556.112-1 .334-1.333.667-.333.332-.555.777-.667 1.333-.111-.557-.334-1.002-.667-1.333C3.5 4.835 3.056 4.613 2.5 4.5c.555-.11.999-.332 1.333-.667z"
      />
    </g>
  </IconBase>
);

export default SparklesIcon;
